import { all, call, put, take } from 'redux-saga/effects';

import { notifications, GET_ANNOTATIONS_FAIL } from 'PipeRouter';
import { GET_ANNOTATIONS, NORMALIZE_ALL } from './actions';
import { getHighlightsAndMarkers } from 'services/learnkit';


function* getAnnotations() {
  yield take(GET_ANNOTATIONS);

  try {
    console.time('getAnnotations#getAnnotations')
    const [ /*vsBookmarks,*/ vsHighlightsAndMarkers ] = yield all([
      // call(getBookmarks),
      call(getHighlightsAndMarkers)
    ]);

    const markersWithId = vsHighlightsAndMarkers.markers.map((marker) => {
      marker.id = marker.globalId;
      return marker;
    });

    vsHighlightsAndMarkers.markers = markersWithId;

    const toNormalize = {
      // vsBookmarks,
      vsHighlightsAndMarkers
    };


    yield put({ type: NORMALIZE_ALL, data: toNormalize });
    console.timeEnd('getAnnotations#getAnnotations')
  } catch (err) {
    console.error(err)
    yield put(notifications(GET_ANNOTATIONS_FAIL));
  }
}


export default getAnnotations;
